import angular from 'angular';
import csmTools from '../tools/tools';

export default angular
  .module('csm.util.filters', [csmTools])

  /*****************************************************************************
   * Filter: boolToString
   *
   * Converts boolean value to 'Y'/'N'
   *****************************************************************************/
  .filter('boolToString', function (Tools) {
    return function (input) {
      return Tools.isEmpty(input)
        ? ''
        : String(input).toLowerCase() == 'true'
        ? 'Y'
        : 'N';
    };
  })

  /*****************************************************************************
   * Filter: percent
   *
   * Converts decimal value to percent. The decimal precision can be passed along
   * with the indication to include '%'.
   *****************************************************************************/
  .filter('percent', function (Tools) {
    return function (input, precision, includeSign) {
      var prec = precision && precision >= 0 ? precision : 0;
      return (
        Tools.formatToPrecision(input * 100, prec) + (includeSign ? '%' : '')
      );
    };
  })

  /*****************************************************************************
   * Filter: phone
   *
   * Display number string as formatted phone number. Passing the display parameter
   * to the formatPhone method. Defaults to true when not provided.
   *****************************************************************************/
  .filter('phone', function (Tools) {
    return function (input, display) {
      return Tools.formatPhone(input, display == undefined || display);
    };
  }).name;
